import { render, staticRenderFns } from "./welcome-screen-settings-dialog.vue?vue&type=template&id=045ca49b&scoped=true&"
import script from "./welcome-screen-settings-dialog.vue?vue&type=script&lang=js&"
export * from "./welcome-screen-settings-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ca49b",
  null
  
)

export default component.exports